import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  roleMYList,
  roleMYDelete,
  roleMYEdit,
} from "../../../../store/actions/menuActions";
import { Popconfirm, message, Empty } from "antd";
import TableWrapper from "../../../../components/Tables";
import Pagination from "../../../../components/Pagination";
import { deleteCategory, listCategory } from "../../../../store/actions/achievementActions";
import { useLocation } from 'react-router-dom';

const AchievementCategoryIndex = () => {
  const [search, setsearch] = useState("");
  const [event, setEvent] = useState();
  const dispatch = useDispatch();
  const history = useHistory();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  } 

  const query = useQuery();
  useEffect(() => setEvent(query.get("event")), [])

  const { achievementCategory, achievementCategoryList } = useSelector((state) => state.achievementCategory);

  const dataLogin = useSelector((state) => state.login);
  let { userInfo } = dataLogin;

  const tableHead = [{ name: "No" }, { name: "Name" }, { name: "Event"} ,{ name: "Action" }];

  const tableBody = [
    { scope: "row" },
    { render: (item) => item.name },
    { render: (item) => item.event_name},
    {
      render: (item) => (
        <div align="center">
            <button
              onClick={() => handleEdit(item.id)}
              className="btn btn-warning btn-sm"
            >
              <i className="fa fa-pencil"></i> Edit{" "}
            </button>
            <Popconfirm
              title="Are you sure to delete this Category?"
              onConfirm={() =>
                dispatch(deleteCategory(item.id)).then(() =>
                  dispatch(listCategory(1, search))
                )
              }
              onCancel={() => message.info("Canceled!")}
              okText="Yes"
              cancelText="No"
            >
              <button className="btn btn-danger btn-sm">
                <i className="fa fa-trash-o"></i> Delete{" "}
              </button>
            </Popconfirm>
        </div>
      ),
    },
  ];

  useEffect(() => {
    dispatch(listCategory(1, search, query.get("event")));
  }, [dispatch]);

  useEffect(() => {
    if (!userInfo || !userInfo.permission) return;
    if (!userInfo.user.roles[0].name == "Super Admin") window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
  }, []);

  const handleEdit = (id) => {
    localStorage.setItem("id_achievement_category", id);
    history.push("/category-edit");
  };

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(listCategory(1, search, event));
  };

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>{event ? `Categories in ${event}` : "Category"}</h3>
        </div>
      </div>
      <div className="clearfix"></div>
      <br/>
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12">
                    <Link
                      to={"/category-create"}
                      className="btn btn-info btn-sm"
                    >
                      Create
                    </Link>
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12 form-group has-feedback">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search By Name"
                    style={{ float: "right", width: "50%", textOverflow: "ellipsis", paddingRight: "33px" }}
                    onChange={(e) => setsearch(e.target.value)}
                  />
                  <button
                    className="fa fa-search form-control-feedback right btn btn-link"
                    style={{
                      height: "100%",
                      margin: "auto",
                      textDecoration: "none",
                    }}
                    aria-hidden="true"
                    onClick={(e) => handleSearch(e)}
                  ></button>
                </div>
              </div>
              <div className="clearfix"></div>
            </div>

            <div className="x_content overflow-auto">
              <TableWrapper
                tableHead={tableHead}
                tableBody={tableBody}
                datas={achievementCategoryList}
              />
              <Pagination datas={achievementCategory} listsData={listCategory} search={search} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchievementCategoryIndex;
